import { DeviceEventEmitter } from 'react-native';
import AuthUtil from 'common/AuthUtil';
import { CreateBSLInterface } from './bsl';

let hasInit = false;
const bslInit = () => {
  if (!hasInit) {
    AuthUtil.initAcountInfo();
    CreateBSLInterface();
    hasInit = true;
    DeviceEventEmitter.addListener('krh_userStatusChange', AuthUtil.onLoginChange);
  }
};

export { bslInit };
